import { useRef } from "react";
import amplitude from "amplitude-js";

const useAmplitude = ({ config, journeyId }) => {
  const amplitudeObjects = useRef(
    Object.entries(config).map(([instanceId, apiKey]) => {
      const instance = amplitude.getInstance(instanceId);
      instance.init(apiKey);

      return {
        instance,
        apiKey,
      };
    }),
  );

  const instanceMaster = useRef({
    logEvent: function () {
      amplitudeObjects.current.forEach(({ instance }) => {
        instance.logEvent(...arguments);
      });
    },
    identify: (key, value) => {
      amplitudeObjects.current.forEach(({ instance }) => {
        const identity = new amplitude.Identify().set(key, value);

        instance.identify(identity);
      });
    },
  });

  return instanceMaster.current;
};

export default useAmplitude;
